import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  log(message: string, data?: any): void {
    if (!environment.production) {
      console.log(`DEV-LOG: ${message}`, data);
    }
  }
  error(message: string, error?: any): void {
    if (!environment.production) {
      console.error(`DEV-ERROR: ${message}`, error);
    }
  }
}
